module.exports = __webpack_public_path__ + "static/img/g1.6e933fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/g1.png
// module id = CQvV
// module chunks = 1